/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/repos/bic-vue/src/components/common/SvgIcon.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "editor-drawer__background flex flex-col flex-nowrap mb-6"
};
const _hoisted_2 = {
  class: "dropdown mx-auto"
};
const _hoisted_3 = {
  class: "m-1 btn btn-ghost h-min"
};
const _hoisted_4 = {
  class: "flex flex-col"
};
const _hoisted_5 = {
  class: "border-white p-1 w-12 h-12"
};
const _hoisted_6 = {
  key: 0,
  class: "p-1"
};
const _hoisted_7 = {
  class: "p-2 pr-5 shadow menu dropdown-content z-[10] -ml-6 bg-base-100 rounded-box"
};
const _hoisted_8 = {
  class: "group-colors flex flex-col"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
import { useConfigurationStore } from "@/stores/configurationModule";
import { ColorPicker } from "vue-color-kit";
export default {
  __name: 'EditorDrawerBackground',
  setup(__props) {
    const configurationStore = useConfigurationStore();
    const {
      activeCanvas
    } = storeToRefs(configurationStore);

    // @TODO: FIND BETTER WAY TO DO THIS, THIS IS A HACK!!!
    // It seems that the color picker we have does not support programmatically setting the color,
    // so i am currently forcing a remount to set the color trough the prop using the :key.
    // If we are going to have the background color grid i think we need either this hack or a different picker.
    // @TODO: Check if it's actually impossible to set color!
    let count = 0;

    // @TODO: REFACTOR THIS should use store and reactivity
    const colorPick = ref(null);
    const colorPicker = ref(null);
    const $eventBus = inject('bus');
    const colorGroups = [['#b71c1c', '#d32f2f', '#e57373', '#ef9a9a', '#ffcdd2'],
    // Red group
    ['#880e4f', '#ad1457', '#c2185b', '#e91e63', '#f8bbd0'],
    // Pink group
    ['#4a148c', '#6a1b9a', '#7b1fa2', '#9c27b0', '#e1bee7'],
    // Purple group
    ['#311b92', '#4527a0', '#512da8', '#673ab7', '#d1c4e9'],
    // Deep Purple group
    ['#1a237e', '#283593', '#303f9f', '#3f51b5', '#c5cae9'],
    // Indigo group
    ['#0d47a1', '#1565c0', '#1976d2', '#2196f3', '#bbdefb'],
    // Blue group
    ['#01579b', '#0277bd', '#0288d1', '#03a9f4', '#b3e5fc'],
    // Light Blue group
    ['#006064', '#00838f', '#0097a7', '#00acc1', '#b2ebf2'],
    // Cyan group
    ['#004d40', '#00695c', '#00796b', '#00897b', '#b2dfdb'],
    // Teal group
    ['#194D33', '#2e7d32', '#388e3c', '#43a047', '#c8e6c9'],
    // Green group
    ['#33691e', '#558b2f', '#689f38', '#8bc34a', '#dcedc8'],
    // Light Green group
    ['#827717', '#9e9d24', '#afb42b', '#cddc39', '#f0f4c3'],
    // Lime group
    ['#f57f17', '#f9a825', '#fbc02d', '#ffeb3b', '#fff9c4'],
    // Yellow group
    ['#ff6f00', '#ff8f00', '#ffa000', '#ffc107', '#ffecb3'],
    // Amber group
    ['#e65100', '#ef6c00', '#f57c00', '#ff9800', '#ffe0b2'],
    // Orange group
    ['#bf360c', '#d84315', '#e64a19', '#ff5722', '#ffccbc'],
    // Deep Orange group
    ['#3e2723', '#4e342e', '#5d4037', '#795548', '#d7ccc8'],
    // Brown group
    ['#263238', '#37474f', '#455a64', '#607d8b', '#cfd8dc'],
    // Blue Grey group
    ['#000000', '#424242', '#757575', '#bdbdbd', '#ffffff'] // Grey group
    ];
    const activeCanvasBackgroundColorLowercase = computed(() => activeCanvas.value._objects[0].fill.toLowerCase());
    onMounted(() => {
      colorPick.value = activeCanvasBackgroundColorLowercase.value;
    });
    function onClickHandleColorSelect(color) {
      colorPick.value = color;
      $eventBus.$emit("background-changed", color);
      count++;
    }
    function handleBackgroundChange(color) {
      const {
        r,
        g,
        b,
        a
      } = color.rgba;
      const rgbaColor = `rgba(${r}, ${g}, ${b}, ${a})`;
      colorPick.value = rgbaColor;
      $eventBus.$emit("background-changed", rgbaColor);
    }
    return (_ctx, _cache) => {
      const _component_SvgIcon = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("details", _hoisted_2, [_createElementVNode("summary", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_SvgIcon, {
        class: "h-full w-full p-[8px] opacity-75",
        fill: "white",
        svgSymbolId: "paint-bucket"
      })]), _unref(colorPick) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
        class: "color-helper w-full h-[5px]",
        style: _normalizeStyle({
          'background-color': _unref(colorPick)
        })
      }, null, 4)])) : _createCommentVNode("", true)])]), _createElementVNode("ul", _hoisted_7, [(_openBlock(), _createBlock(_unref(ColorPicker), {
        class: "background-color-picker",
        key: _unref(count),
        ref_key: "colorPicker",
        ref: colorPicker,
        style: {
          "width": "220px"
        },
        theme: "dark",
        color: _unref(colorPick),
        onChangeColor: handleBackgroundChange
      }, null, 8, ["color"]))])]), (_openBlock(), _createElementBlock("div", {
        key: _unref(colorPick),
        class: "grid grid-cols-4 gap-4 pt-4"
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(colorGroups, (colorGroup, index) => {
        return _createElementVNode("div", {
          key: `cg-${index}`
        }, [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorGroup, color => {
          return _openBlock(), _createElementBlock("div", {
            key: `color-${color}`,
            class: _normalizeClass(["relative flex justify-center items-center mb-[1px] h-[36px] w-full hover:border-[0.2px] border-white cursor-pointer", {
              active: color === _unref(colorPick)
            }]),
            style: _normalizeStyle(`background-color: ${color}`),
            onClick: $event => onClickHandleColorSelect(color)
          }, [(_openBlock(), _createElementBlock("span", {
            key: _unref(colorPick),
            class: _normalizeClass(["active-color-background absolute top-0 left-0 w-full h-full opacity-0 border transition-opacity duration-200 ease-in-out", {
              'opacity-100': color === _unref(colorPick)
            }])
          }, [_createVNode(_component_SvgIcon, {
            svgSymbolId: "check",
            class: _normalizeClass(["w-4 h-4", {
              'bg-slate-700': color === _unref(colorPick)
            }])
          }, null, 8, ["class"])], 2))], 14, _hoisted_9);
        }), 128)), _hoisted_10])]);
      }), 64))]))]);
    };
  }
};